<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M2.3999 0.650391V7.65039M2.3999 7.65039C1.4334 7.65039 0.649902 8.43389 0.649902 9.40039C0.649902 10.3669 1.4334 11.1504 2.3999 11.1504C3.3664 11.1504 4.1499 10.3669 4.1499 9.40039M2.3999 7.65039C3.3664 7.65039 4.1499 8.43389 4.1499 9.40039M9.3999 4.15039C10.3664 4.15039 11.1499 3.36689 11.1499 2.40039C11.1499 1.43389 10.3664 0.650391 9.3999 0.650391C8.4334 0.650391 7.6499 1.43389 7.6499 2.40039C7.6499 3.36689 8.4334 4.15039 9.3999 4.15039ZM9.3999 4.15039C9.3999 5.54278 8.84678 6.87814 7.86221 7.8627C6.87765 8.84727 5.54229 9.40039 4.1499 9.40039"
    stroke="var(--stroke-color)"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
